import { createRequestTypes } from '../../utils';
import formNames from '../../../constants/formNames';


const formName = formNames.editInciListForm;

export const SAVE_FORM = createRequestTypes(`${formName}/SAVE_FORM`);
